export default "__VITE_ASSET__d37598b8__"